import * as R from 'ramda'

import type { Filter, Searchline } from '../flow'

import { filterIsChart, filterIsTimePeriod } from './index'

export function filtersToURLParam(filters: Array<Filter>): string {
  return filters?.map(({ id, type }) => `${type}${id ? `:${id}` : ''}`).join(';')
}

/**
 * Translates searchdata into URL params string
 * @param searchterm
 * @param filters
 * @param timestamp
 * @returns {string}
 */
export function searchDataToURLParam({ searchterm, filters }: Searchline) {
  const paramsArray = [
    searchterm ? `expression=${encodeURIComponent(searchterm)}` : '',
    filters && filters.length ? `filters=${filtersToURLParam(filters)}` : '',
  ].filter((x) => x !== '')

  return `?${paramsArray.join('&')}`
}

export function parseFiltersFromURLParam(filtersString?: string): Array<Filter> {
  return filtersString
    ? filtersString
        .split(';')
        ?.map((x) => x.split(':'))
        ?.map(([type, id]) => ({ id, type }))
    : []
}

export function profileIdFromLocationQuery(locationQueryFiltersParam: string): number {
  if (!locationQueryFiltersParam) {
    // @ts-expect-error: Muted so we could enable TS strict mode
    return null
  }
  const [filter] = parseFiltersFromURLParam(locationQueryFiltersParam)

  return +filter.id
}

export const periodAndChartAndNonChartFiltersFromURL = (
  filtersParam: string,
): { nonChartFilters: Array<Filter>; chartFilter: Filter | void; timePeriodFilter: Filter | void } => {
  const parsedFilters: Array<Filter> = parseFiltersFromURLParam(filtersParam)
  const chartFilter = parsedFilters.find(filterIsChart)
  const timePeriodFilter = parsedFilters.find(filterIsTimePeriod)

  // @ts-expect-error: Muted so we could enable TS strict mode
  return { nonChartFilters: R.without([chartFilter], parsedFilters), chartFilter, timePeriodFilter }
}

export const paramsDictToUrl: (query: { [key: string]: string }) => string = R.compose(
  R.join(''),
  R.intersperse('&'),
  R.map(R.join('=')),
  R.toPairs,
)
